module.exports = __webpack_public_path__ + "img/warning.e015c0d8.svg";